// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.w-100 {
  width: 100%;
}

.loading {
  background-color: #F2F2F2;
  margin: 0;
  position: fixed;
  top: 0px;
  right: 0px;
  z-index: 1;
  overflow: hidden !important;
}

.text-color {
  color: #404040;
}

.sk-folding-cube {
  margin: 20px auto;
  width: 40px;
  height: 40px;
  position: relative;
  transform: rotateZ(45deg);
}

.sk-folding-cube .sk-cube {
  float: left;
  width: 50%;
  height: 50%;
  position: relative;
  transform: scale(1.1);
}

.sk-folding-cube .sk-cube:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #404040;
  animation: sk-foldCubeAngle 2.4s infinite linear both;
  transform-origin: 100% 100%;
}

.sk-folding-cube .sk-cube2 {
  transform: scale(1.1) rotateZ(90deg);
}

.sk-folding-cube .sk-cube3 {
  transform: scale(1.1) rotateZ(180deg);
}

.sk-folding-cube .sk-cube4 {
  transform: scale(1.1) rotateZ(270deg);
}

.sk-folding-cube .sk-cube2:before {
  animation-delay: 0.3s;
}

.sk-folding-cube .sk-cube3:before {
  animation-delay: 0.6s;
}

.sk-folding-cube .sk-cube4:before {
  animation-delay: 0.9s;
}
@keyframes sk-foldCubeAngle {
  0%, 10% {
    transform: perspective(140px) rotateX(-180deg);
    opacity: 0;
  }
  25%, 75% {
    transform: perspective(140px) rotateX(0deg);
    opacity: 1;
  }
  90%, 100% {
    transform: perspective(140px) rotateY(180deg);
    opacity: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/core/login/login.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;AACJ;;AAEA;EACI,yBAAA;EAEA,SAAA;EACA,eAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EAEA,2BAAA;AADJ;;AAIA;EACE,cAAA;AADF;;AAIA;EACI,iBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EAEQ,yBAAA;AADZ;;AAIE;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EAGQ,qBAAA;AADZ;;AAGE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EAEQ,qDAAA;EAGA,2BAAA;AAAZ;;AAEE;EAEU,oCAAA;AACZ;;AACE;EAEU,qCAAA;AAEZ;;AAAE;EAEU,qCAAA;AAGZ;;AADE;EAEU,qBAAA;AAIZ;;AAFE;EAEU,qBAAA;AAKZ;;AAHE;EAEU,qBAAA;AAMZ;AAYE;EACE;IAEU,8CAAA;IACR,UAAA;EAQJ;EAPI;IAEQ,2CAAA;IACR,UAAA;EASJ;EARI;IAEQ,6CAAA;IACR,UAAA;EAUJ;AACF","sourcesContent":[".w-100{\n    width: 100%;\n}\n\n.loading {\n    background-color: #F2F2F2;\n\n    margin: 0;\n    position: fixed;\n    top: 0px;\n    right: 0px;\n    z-index: 1;\n\n    overflow: hidden !important;\n}\n\n.text-color{\n  color:#404040;\n}\n\n.sk-folding-cube {\n    margin: 20px auto;\n    width: 40px;\n    height: 40px;\n    position: relative;\n    -webkit-transform: rotateZ(45deg);\n            transform: rotateZ(45deg);\n  }\n  \n  .sk-folding-cube .sk-cube {\n    float: left;\n    width: 50%;\n    height: 50%;\n    position: relative;\n    -webkit-transform: scale(1.1);\n        -ms-transform: scale(1.1);\n            transform: scale(1.1); \n  }\n  .sk-folding-cube .sk-cube:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: #404040;\n    -webkit-animation: sk-foldCubeAngle 2.4s infinite linear both;\n            animation: sk-foldCubeAngle 2.4s infinite linear both;\n    -webkit-transform-origin: 100% 100%;\n        -ms-transform-origin: 100% 100%;\n            transform-origin: 100% 100%;\n  }\n  .sk-folding-cube .sk-cube2 {\n    -webkit-transform: scale(1.1) rotateZ(90deg);\n            transform: scale(1.1) rotateZ(90deg);\n  }\n  .sk-folding-cube .sk-cube3 {\n    -webkit-transform: scale(1.1) rotateZ(180deg);\n            transform: scale(1.1) rotateZ(180deg);\n  }\n  .sk-folding-cube .sk-cube4 {\n    -webkit-transform: scale(1.1) rotateZ(270deg);\n            transform: scale(1.1) rotateZ(270deg);\n  }\n  .sk-folding-cube .sk-cube2:before {\n    -webkit-animation-delay: 0.3s;\n            animation-delay: 0.3s;\n  }\n  .sk-folding-cube .sk-cube3:before {\n    -webkit-animation-delay: 0.6s;\n            animation-delay: 0.6s; \n  }\n  .sk-folding-cube .sk-cube4:before {\n    -webkit-animation-delay: 0.9s;\n            animation-delay: 0.9s;\n  }\n  @-webkit-keyframes sk-foldCubeAngle {\n    0%, 10% {\n      -webkit-transform: perspective(140px) rotateX(-180deg);\n              transform: perspective(140px) rotateX(-180deg);\n      opacity: 0; \n    } 25%, 75% {\n      -webkit-transform: perspective(140px) rotateX(0deg);\n              transform: perspective(140px) rotateX(0deg);\n      opacity: 1; \n    } 90%, 100% {\n      -webkit-transform: perspective(140px) rotateY(180deg);\n              transform: perspective(140px) rotateY(180deg);\n      opacity: 0; \n    } \n  }\n  \n  @keyframes sk-foldCubeAngle {\n    0%, 10% {\n      -webkit-transform: perspective(140px) rotateX(-180deg);\n              transform: perspective(140px) rotateX(-180deg);\n      opacity: 0; \n    } 25%, 75% {\n      -webkit-transform: perspective(140px) rotateX(0deg);\n              transform: perspective(140px) rotateX(0deg);\n      opacity: 1; \n    } 90%, 100% {\n      -webkit-transform: perspective(140px) rotateY(180deg);\n              transform: perspective(140px) rotateY(180deg);\n      opacity: 0; \n    }\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
